export const EVENT_SET = "EVENT::SET"
export const EVENT_CLEAR = "EVENT::CLEAR"
export const EVENT_SET_STATS = "EVENT::SET::STATS"
export const EVENT_UPDATE_STATS = "EVENT::UPDATE::STATS"
export const EVENT_SPONSORS_MOVE = "EVENT::SPONSORS::MOVE"



// WEBPACK FOOTER //
// ./src/types/actions/event.js